import React from "react";
import { Link } from "react-router-dom";
import BackgroundWrapper from "../components/BackgroundWrapper";


export default function Contact() {
  return (
    <BackgroundWrapper>
     
      <div className="pt-8 pb-20 px-4 min-h-screen flex items-center">
        <div className="max-w-4xl mx-auto bg-white/90 backdrop-blur-md rounded-3xl shadow-2xl p-10 md:p-16 text-center">

          {/* 🔹 Back Button */}
          <div className="text-left mb-6">
            <Link
              to="/"
              className="text-blue-600 hover:text-blue-700 font-semibold inline-flex items-center"
            >
              ← Back to Home
            </Link>
          </div>

          <h1 className="text-4xl font-bold text-slate-800 mb-8">Contact Us</h1>
          <p className="text-lg text-slate-700 mb-10">
            For inquiries, collaborations, or leadership development opportunities, 
            please feel free to reach out to us.
          </p>

          <div className="space-y-5 text-slate-700 text-lg mb-10 text-left md:text-center">
             <p className="text-sm sm:text-base">
        📧 <strong>Email:</strong>{" "}
        <a
          href="mailto:info@graycoats.co"
          className="text-blue-600 hover:underline"
        >
          info@graycoats.co
        </a>
      </p>

      <p className="text-sm sm:text-base">
        📍 <strong>Address:</strong>{" "}
        <span className="text-slate-800 font-medium">
          Michel Boustros Street, Achrafieh, Beirut
        </span>
      </p>

      <p className="text-sm sm:text-base">
        ☎️ <strong>Phone:</strong>{" "}
        <a
          href="tel:+9611444004"
          className="text-blue-600 hover:underline font-semibold"
        >
          01 444 004
        </a>
      </p>

      <p className="text-sm sm:text-base">
        🌐 <strong>Google Maps:</strong>{" "}
        <a
          href="https://maps.app.goo.gl/q5XVRgxjgV1bYyyM6?g_st=com.google.maps.preview.copy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:underline"
        >
          View on Google Maps
        </a>
      </p>
          </div>

          {/* 🗺️ Embedded Google Map (inside card, not full page) */}
          

          <div className="border-t border-slate-300 pt-8 text-slate-600 text-sm">
            <p className="mb-1">
              Participants in formal training obtain certificates accredited by the 
              UK Continuing Professional Development (CPD) program.
            </p>
            <p>
              Coaching is regulated and certified by the 
              <strong> International Coaching Federation (ICF)</strong>.
            </p>
          </div>
        </div>
      </div>
    </BackgroundWrapper>
  );
}
